// extracted by mini-css-extract-plugin
export default {"login-link":"UL4G7","register-button":"ghptg"};